
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Message } from 'element-ui'
import {userApi} from "@/api/organization";
import SlideCaptcha from "@/components/SlideCaptcha.vue";
import {mapMutations} from "vuex";

@Component({
  components: {SlideCaptcha}
})
export default class ChangeUserPwd extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  visible!: boolean

  @Prop({
    type: String,
    default: ''
  })
  loginName!: string

  loading = false
  passwordStrength = 0
  isShowSelf = false
  form = {
    loginName: '',
    oldPwd: '',
    newPwd: '',
    newPwd2: ''
  }

  rules = {
    loginName: [
      { required: true, message: '请输入用户名', trigger: 'blur' }
    ],
    oldPwd: [
      { required: true, message: '请输入旧密码', trigger: 'blur' }
    ],
    newPwd: [
      { required: true, message: '请输入新密码', trigger: 'blur' },
      { min: 8, message: '密码长度不能少于8个字符', trigger: 'blur' },
      {
        validator: (rule: any, value: string, callback: (error?: Error) => void): void => {
          const passwordRegex = new RegExp('^(?=.*[a-zA-Z])(?=.*\\d).{8,16}$')
          if (!passwordRegex.test(value)) {
            callback(new Error('密码必须由8-16位的数字和大小写字母组成'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    ],
    newPwd2: [
      { required: true, message: '请确认新密码', trigger: 'blur' },
      {
        validator: (rule: any, value: string, callback: (error?: Error) => void): void => {
          if (value !== this.form.newPwd) {
            callback(new Error('两次输入密码不一致'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    ]
  }

  @Watch('loginName')
  onLoginNameChange(newVal: string): void {
    this.form.loginName = newVal
  }

  mounted(): void {
    this.form.loginName = this.loginName
  }

  get passwordStrengthClass(): string {
    if (this.passwordStrength === 0) return 'strength-weak'
    if (this.passwordStrength === 1) return 'strength-medium'
    if (this.passwordStrength === 2) return 'strength-strong'
    return 'strength-weak'
  }

  get passwordStrengthText(): string {
    if (this.passwordStrength === 0) return '弱'
    if (this.passwordStrength === 1) return '中'
    if (this.passwordStrength === 2) return '强'
    return '弱'
  }

  checkPasswordStrength(value: string): void {
    let strength = 0
    if (value.length >= 8) strength++
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) strength++
    if (/\d/.test(value) && /[^A-Za-z0-9]/.test(value)) strength++
    this.passwordStrength = Math.min(strength, 2)
  }

  async submitForm(): Promise<void> {
    const form = this.$refs['changePwdForm'] as HTMLFormElement;
    if (!form) return

    form.validate(async (valid: boolean) => {
      if (valid) {
        // 检查密码强度
        if (this.passwordStrength === 0) {
          Message.error('密码强度太弱，请使用更强的密码')
          return
        }
        this.isShowSelf = true;
        this.$nextTick(() => {
          const slideCaptcha = this.$refs['slideCaptcha'] as any;
          slideCaptcha?.refresh();
        });
      }
    })
  }

  cancel(): void {
    this.$emit('cancel')
    this.$emit('update:visible', false)
    this.resetForm()
  }

  handleClose(): void {
    this.$emit('cancel')
    this.$emit('update:visible', false)
    this.resetForm()
  }

  onCaptchaSuccess(data: any){
    this.isShowSelf = false;
    userApi.changeUserPwdNotLogin(this.form.loginName, this.form.oldPwd, this.form.newPwd, data.captchaId, data.moveX).then((res: any) => {
      if(res.data.result === 0){
          this.$message.success("修改成功！");
          this.handleClose();
      }
    });
  }

  resetForm(): void {
    this.form.oldPwd = ''
    this.form.newPwd = ''
    this.form.newPwd2 = ''
    this.passwordStrength = 0
    const form = this.$refs['changePwdForm'] as HTMLFormElement;
    if (form) {
      form.resetFields();
    }
  }
}
